// Document-date-first sort helpers for the patient document list.
// `documentDate` is a user-editable string set in the document editor; it is
// the canonical chronological key. We fall back to `modifiedAt` then
// `createdAt` only when `documentDate` is missing (legacy / in-flight docs).

export const getTimestampFromValue = (value) => {
  if (!value) return 0;

  if (value?.toDate && typeof value.toDate === 'function') {
    return value.toDate().getTime();
  }

  if (typeof value?.seconds === 'number') {
    return value.seconds * 1000;
  }

  if (value instanceof Date) {
    return value.getTime();
  }

  if (typeof value === 'number') {
    return value;
  }

  if (typeof value === 'string') {
    const mmddyyyy = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (mmddyyyy) {
      const month = Number(mmddyyyy[1]) - 1;
      const day = Number(mmddyyyy[2]);
      const year = Number(mmddyyyy[3]);
      return new Date(year, month, day).getTime();
    }

    const parsed = Date.parse(value);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  return 0;
};

export const getDocumentDateSortValue = (doc) => {
  const documentDateTs = getTimestampFromValue(doc?.documentDate);
  if (documentDateTs > 0) return documentDateTs;

  const modifiedTs = getTimestampFromValue(doc?.modifiedAt);
  if (modifiedTs > 0) return modifiedTs;

  return getTimestampFromValue(doc?.createdAt);
};

export const formatExportDate = value => {
  const milliseconds = getTimestampFromValue(value);
  const date = new Date(milliseconds);
  // Historical malformed sentinels have no recoverable export time.
  if (!milliseconds || !Number.isFinite(date.getTime())) return 'Date unavailable';
  return date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
};

export const sortDocumentsByDateDesc = (documents) =>
  [...documents].sort(
    (a, b) => getDocumentDateSortValue(b) - getDocumentDateSortValue(a)
  );
